module.exports = __webpack_public_path__ + "img/field-level-endzone-gal-8.71cdcab0.jpg";